<template>
  <BaseVeeForm :action="submitForm">
    <template #default="formProps">
      <div
        v-for="(item, idx) in formData.accOrderStatusToDocumentSeries"
        :key="idx"
        class="bg-white flex items-center"
      >
        <div class="flex-1 px-6 py-4 capitalize">
          {{ item.status }}
        </div>
        <div class="flex-1 px-6 py-4">
          <ValidationProvider
            rules="required"
            name="series"
            slim
            :vid="`document_types.${idx}.series`"
          >
            <template #default="{ errors }">
              <div>
                <BaseFormSelect
                  v-model="item.series"
                  :options="seriesOptions"
                  :disabled="formProps.isPending"
                  required
                  class="w-full"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </div>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4 flex space-x-2">
          <button
            type="button"
            class="w-full inline-flex items-center px-4 py-2 border text-sm justify-center font-medium rounded-md bg-white focus:outline-none disabled:border-transparent disabled:text-gray-500 border-gray-300 text-red-600 hover:bg-gray-50 focus:border-blue-600"
            :disabled="formProps.isPending || formProps.invalid"
            @click="removeAccOrderStatusToDocumentSeries(idx)"
          >
            Remove
          </button>
        </div>
      </div>
      <div class="px-6 py-4">
        <button
          type="submit"
          class="w-full inline-flex items-center px-4 py-2 border text-sm justify-center font-medium rounded-md bg-white focus:outline-none disabled:border-transparent disabled:text-gray-500 border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
          :disabled="formProps.isPending || formProps.invalid"
        >
          Update
        </button>
      </div>
    </template>
  </BaseVeeForm>
</template>

<script>
import { omit } from 'lodash-es';
import { softOneApiServiceConfigAccOrderStatusesClient } from '@/api/clients';

export default {
  props: {
    softOneServiceId: {
      type: String,
      required: true,
    },
    initialData: {
      type: Array,
      required: true,
    },
    seriesOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        accOrderStatusToDocumentSeries: [...this.initialData],
      },
    };
  },
  watch: {
    initialData: 'updateInitialData',
  },
  methods: {
    updateInitialData(initialData) {
      this.formData.accOrderStatusToDocumentSeries = [...initialData];
    },
    removeAccOrderStatusToDocumentSeries(index) {
      this.formData.accOrderStatusToDocumentSeries = [
        ...Object.values(omit(this.formData.accOrderStatusToDocumentSeries, [index])),
      ];
    },
    async submitForm() {
      try {
        this.$emit('updating');
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.softOneServiceId,
          formData: { ...this.formData },
          service: softOneApiServiceConfigAccOrderStatusesClient.update,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.$emit('updated');
      }
    },
  },
};
</script>
